import React, { Component, createRef } from 'react';
import OptionOverlayProps from './OptionOverlay.props';
import OptionOverlayState from './OptionOverlay.state';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';

export default class OptionOverlay extends Component<OptionOverlayProps, OptionOverlayState> {
    context!: React.ContextType<typeof GlobalContext>;
    optionOverlayRef = createRef<HTMLDivElement>();

    constructor(props: OptionOverlayProps) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        if (this.props.isOpen) {
            this.addListener()
        }
    }

    componentDidUpdate(prevProps: OptionOverlayProps) {
        if (prevProps.isOpen !== this.props.isOpen) {
            this.updateAndNotify();
        }
    }

    updateAndNotify = () => {
        if (this.props.isOpen) {
            this.addListener();
        } else {
            this.removeListener();
        }
    }

    componentWillUnmount() {
        this.removeListener();
    }

    addListener() {
        // to prevent multiple events with one click
        setTimeout(() => {
            document.addEventListener('click', this.handleClickOutside);
            document.addEventListener('keyup', this.handleKeyPress);
        }, 50)
    }

    removeListener() {
        document.removeEventListener('click', this.handleClickOutside);
        document.removeEventListener('keyup', this.handleKeyPress);
    }

    handleClickOutside = (event: MouseEvent) => {
        const target = event.target as HTMLElement;
        if (this.optionOverlayRef.current && !this.optionOverlayRef.current.contains(target)) {
            this.props.onClose?.();
        }
    }

    handleKeyPress = (event: KeyboardEvent) => {
        if(event.key === "Escape") {
            this.props.onClose?.();
        }
    }

    render(): React.ReactNode {
        return (
            this.props.isOpen ?
                <div className="option-overlay" data-testid="OptionOverlay" ref={this.optionOverlayRef}>
                    <div className='option-overlay__overlay'>
                        {this.props.children}
                    </div>
                </div>
                : <></>
        );
    }
}
